// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   Universal Layout (All Pages)
   Flat Design System
   =================================== */

.universal-layout {
  display: flex;
  height: 100vh;
  width: 100%;
  background: var(--color-bg-root);
  overflow: hidden;
}

.universal-layout__content {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  background: var(--color-bg-root);
}
`, "",{"version":3,"sources":["webpack://./src/components/UniversalLayout.css"],"names":[],"mappings":"AAAA;;;wCAGwC;;AAExC;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC","sourcesContent":["/* ===================================\n   Universal Layout (All Pages)\n   Flat Design System\n   =================================== */\n\n.universal-layout {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  background: var(--color-bg-root);\n  overflow: hidden;\n}\n\n.universal-layout__content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n  background: var(--color-bg-root);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
